import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import Header from "../Header/Header";
import Hero from "../Hero/Hero";
import Footer from "../Footer/footer";
import Deliver from "./Deliver";
import Control from "./Control";
import Rightforyou from "./Rightforyou";
import WhyFrothTestops from "./WhyFrothTestops";
import Count from "./Count";

const WhyTestops = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialGetTestOps = params.get("clicked") === "true";

  return (
    <>
      <Helmet>
        <title>
          Top AI Software Testing Tools to Boost QA Efficiency
        </title>

        <meta
          name="description"
          content="Discover top AI software testing tools to streamline QA workflows, enhance team collaboration, boost test efficiency, and deliver projects faster."
        />

        <meta
          name="keywords"
          content="Ai Software Testing Tools"
        />

        <link
          rel="canonical"
          href="https://frothtestops.com/why-testops"
        />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Top AI Software Testing Tools to Boost QA Efficiency" />
        <meta property="og:description" content="Discover top AI software testing tools to streamline QA workflows, enhance team collaboration, boost test efficiency, and deliver projects faster." />
        <meta property="og:image" content="/images/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://frothtestops.com/why-testops" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Top AI Software Testing Tools to Boost QA Efficiency" />
        <meta name="twitter:description" content="Discover top AI software testing tools to streamline QA workflows, enhance team collaboration, boost test efficiency, and deliver projects faster." />
        <meta name="twitter:image" content="/images/og-image.jpg" />
      </Helmet>

      <div
        className={`fd-main-wrapper ${
          location.pathname !== "/" ? "page-padding" : ""
        }`}
      >
        <Header />

        <Deliver />
        <Control />
        <Rightforyou getTestOps={initialGetTestOps} />
        <Count />
        <WhyFrothTestops />

        <Footer />
      </div>
    </>
  );
};

export default WhyTestops;